module.exports = __webpack_public_path__ + "img/share-poster.9fb7c8ab.png";